export default {
      id: "deco_actus-usage",
      viewBox: "0 0 350 355",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#deco_actus-usage",
      toString: function () {
        return this.url;
      }
    }